module.exports = __webpack_public_path__ + "img/members.5fb648dc.svg";